export default "__VITE_ASSET__BTImzNQd__"